const resolveUserTimezone = () => {
	const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
	return tz === 'Etc/Unknown' ? 'Etc/UTC' : tz;
};

function timezoneToLocale(timeZone: string) {
	switch (timeZone) {
		case 'Europe/Andorra':
			return 'ca-AD';
		case 'Asia/Dubai':
			return 'ar-AE';
		case 'Asia/Kabul':
			return 'ps-AF';
		case 'Europe/Tirane':
			return 'sq-AL';
		case 'Asia/Yerevan':
			return 'hy-AM';
		case 'Antarctica/Casey':
			return 'en-AU';
		case 'Antarctica/Davis':
			return 'en-AU';
		case 'Antarctica/DumontDUrville':
			return 'fr-TF';
		case 'Antarctica/Mawson':
			return 'en-AU';
		case 'Antarctica/Palmer':
			return 'en-US';
		case 'Antarctica/Rothera':
			return 'en-GB';
		case 'Antarctica/Syowa':
			return 'ja-JP';
		case 'Antarctica/Troll':
			return 'no-NO';
		case 'Antarctica/Vostok':
			return 'ru-RU';
		case 'America/Argentina/Buenos_Aires':
			return 'es-AR';
		case 'America/Argentina/Cordoba':
			return 'es-AR';
		case 'America/Argentina/Salta':
			return 'es-AR';
		case 'America/Argentina/Jujuy':
			return 'es-AR';
		case 'America/Argentina/Tucuman':
			return 'es-AR';
		case 'America/Argentina/Catamarca':
			return 'es-AR';
		case 'America/Argentina/La_Rioja':
			return 'es-AR';
		case 'America/Argentina/San_Juan':
			return 'es-AR';
		case 'America/Argentina/Mendoza':
			return 'es-AR';
		case 'America/Argentina/San_Luis':
			return 'es-AR';
		case 'America/Argentina/Rio_Gallegos':
			return 'es-AR';
		case 'America/Argentina/Ushuaia':
			return 'es-AR';
		case 'Pacific/Pago_Pago':
			return 'en-WS';
		case 'Europe/Vienna':
			return 'de-AT';
		case 'Australia/Lord_Howe':
			return 'en-AU';
		case 'Antarctica/Macquarie':
			return 'en-AU';
		case 'Australia/Hobart':
			return 'en-AU';
		case 'Australia/Currie':
			return 'en-AU';
		case 'Australia/Melbourne':
			return 'en-AU';
		case 'Australia/Sydney':
			return 'en-AU';
		case 'Australia/Broken_Hill':
			return 'en-AU';
		case 'Australia/Brisbane':
			return 'en-AU';
		case 'Australia/Lindeman':
			return 'en-AU';
		case 'Australia/Adelaide':
			return 'en-AU';
		case 'Australia/Darwin':
			return 'en-AU';
		case 'Australia/Perth':
			return 'en-AU';
		case 'Australia/Eucla':
			return 'en-AU';
		case 'Asia/Baku':
			return 'az-AZ';
		case 'America/Barbados':
			return 'en-BB';
		case 'Asia/Dhaka':
			return 'bn-BD';
		case 'Europe/Brussels':
			return 'nl-BE';
		case 'Europe/Sofia':
			return 'bg-BG';
		case 'Atlantic/Bermuda':
			return 'en-BM';
		case 'Asia/Brunei':
			return 'ms-BN';
		case 'America/La_Paz':
			return 'es-BO';
		case 'America/Noronha':
			return 'pt-BR';
		case 'America/Belem':
			return 'pt-BR';
		case 'America/Fortaleza':
			return 'pt-BR';
		case 'America/Recife':
			return 'pt-BR';
		case 'America/Araguaina':
			return 'pt-BR';
		case 'America/Maceio':
			return 'pt-BR';
		case 'America/Bahia':
			return 'pt-BR';
		case 'America/Sao_Paulo':
			return 'pt-BR';
		case 'America/Campo_Grande':
			return 'pt-BR';
		case 'America/Cuiaba':
			return 'pt-BR';
		case 'America/Santarem':
			return 'pt-BR';
		case 'America/Porto_Velho':
			return 'pt-BR';
		case 'America/Boa_Vista':
			return 'pt-BR';
		case 'America/Manaus':
			return 'pt-BR';
		case 'America/Eirunepe':
			return 'pt-BR';
		case 'America/Rio_Branco':
			return 'pt-BR';
		case 'America/Nassau':
			return 'en-BS';
		case 'Asia/Thimphu':
			return 'dz-BT';
		case 'Europe/Minsk':
			return 'be-BY';
		case 'America/Belize':
			return 'en-BZ';
		case 'America/St_Johns':
			return 'en-CA';
		case 'America/Halifax':
			return 'en-CA';
		case 'America/Glace_Bay':
			return 'en-CA';
		case 'America/Moncton':
			return 'en-CA';
		case 'America/Goose_Bay':
			return 'en-CA';
		case 'America/Blanc-Sablon':
			return 'fr-CA';
		case 'America/Toronto':
			return 'en-CA';
		case 'America/Nipigon':
			return 'en-CA';
		case 'America/Thunder_Bay':
			return 'en-CA';
		case 'America/Iqaluit':
			return 'en-CA';
		case 'America/Pangnirtung':
			return 'en-CA';
		case 'America/Atikokan':
			return 'en-CA';
		case 'America/Winnipeg':
			return 'en-CA';
		case 'America/Rainy_River':
			return 'en-CA';
		case 'America/Resolute':
			return 'en-CA';
		case 'America/Rankin_Inlet':
			return 'en-CA';
		case 'America/Regina':
			return 'en-CA';
		case 'America/Swift_Current':
			return 'en-CA';
		case 'America/Edmonton':
			return 'en-CA';
		case 'America/Cambridge_Bay':
			return 'en-CA';
		case 'America/Yellowknife':
			return 'en-CA';
		case 'America/Inuvik':
			return 'en-CA';
		case 'America/Creston':
			return 'en-CA';
		case 'America/Dawson_Creek':
			return 'en-CA';
		case 'America/Fort_Nelson':
			return 'en-CA';
		case 'America/Vancouver':
			return 'en-CA';
		case 'America/Whitehorse':
			return 'en-CA';
		case 'America/Dawson':
			return 'en-CA';
		case 'Indian/Cocos':
			return 'en-CC';
		case 'Europe/Zurich':
			return 'de-CH';
		case 'Africa/Abidjan':
			return 'fr-CI';
		case 'Pacific/Rarotonga':
			return 'en-CK';
		case 'America/Santiago':
			return 'es-CL';
		case 'America/Punta_Arenas':
			return 'es-CL';
		case 'Pacific/Easter':
			return 'es-CL';
		case 'Asia/Shanghai':
			return 'zh-CN';
		case 'Asia/Urumqi':
			return 'zh-CN';
		case 'America/Bogota':
			return 'es-CO';
		case 'America/Costa_Rica':
			return 'es-CR';
		case 'America/Havana':
			return 'es-CU';
		case 'Atlantic/Cape_Verde':
			return 'pt-CV';
		case 'America/Curacao':
			return 'nl-CW';
		case 'Indian/Christmas':
			return 'en-KI';
		case 'Asia/Nicosia':
			return 'el-CY';
		case 'Asia/Famagusta':
			return 'el-CY';
		case 'Europe/Prague':
			return 'cs-CZ';
		case 'Europe/Berlin':
			return 'de-DE';
		case 'Europe/Copenhagen':
			return 'da-DK';
		case 'America/Santo_Domingo':
			return 'es-DO';
		case 'Africa/Algiers':
			return 'ar-DZ';
		case 'America/Guayaquil':
			return 'es-EC';
		case 'Pacific/Galapagos':
			return 'es-EC';
		case 'Europe/Tallinn':
			return 'et-EE';
		case 'Africa/Cairo':
			return 'ar-EG';
		case 'Africa/El_Aaiun':
			return 'ar-EH';
		case 'Europe/Madrid':
			return 'es-ES';
		case 'Africa/Ceuta':
			return 'es-ES';
		case 'Atlantic/Canary':
			return 'es-ES';
		case 'Europe/Helsinki':
			return 'fi-FI';
		case 'Pacific/Fiji':
			return 'en-FJ';
		case 'Atlantic/Stanley':
			return 'en-FK';
		case 'Pacific/Chuuk':
			return 'en-FM';
		case 'Pacific/Pohnpei':
			return 'en-FM';
		case 'Pacific/Kosrae':
			return 'en-FM';
		case 'Atlantic/Faroe':
			return 'fo-FO';
		case 'Europe/Paris':
			return 'fr-FR';
		case 'Europe/London':
			return 'en-GB';
		case 'Asia/Tbilisi':
			return 'ka-GE';
		case 'America/Cayenne':
			return 'fr-GF';
		case 'Africa/Accra':
			return 'en-GH';
		case 'Europe/Gibraltar':
			return 'en-GI';
		case 'America/Godthab':
			return 'kl-GL';
		case 'America/Danmarkshavn':
			return 'kl-GL';
		case 'America/Scoresbysund':
			return 'kl-GL';
		case 'America/Thule':
			return 'kl-GL';
		case 'Europe/Athens':
			return 'el-GR';
		case 'Atlantic/South_Georgia':
			return 'en-GS';
		case 'America/Guatemala':
			return 'es-GT';
		case 'Pacific/Guam':
			return 'en-Gu';
		case 'Africa/Bissau':
			return 'pt-GW';
		case 'America/Guyana':
			return 'en-GY';
		case 'Asia/Hong_Kong':
			return 'zh-HK';
		case 'America/Tegucigalpa':
			return 'es-HN';
		case 'America/Port-au-Prince':
			return 'fr-HT';
		case 'Europe/Budapest':
			return 'hu-HU';
		case 'Asia/Jakarta':
			return 'id-ID';
		case 'Asia/Pontianak':
			return 'id-ID';
		case 'Asia/Makassar':
			return 'id-ID';
		case 'Asia/Jayapura':
			return 'id-ID';
		case 'Europe/Dublin':
			return 'en-IE';
		case 'Asia/Jerusalem':
			return 'he-IL';
		case 'Asia/Kolkata':
			return 'hi-IN';
		case 'Indian/Chagos':
			return 'en-IO';
		case 'Asia/Baghdad':
			return 'ar-IQ';
		case 'Asia/Tehran':
			return 'fa-IR';
		case 'Atlantic/Reykjavik':
			return 'is-IS';
		case 'Europe/Rome':
			return 'it-IT';
		case 'America/Jamaica':
			return 'en-JM';
		case 'Asia/Amman':
			return 'ar-JO';
		case 'Asia/Tokyo':
			return 'ja-JP';
		case 'Africa/Nairobi':
			return 'sw-KE';
		case 'Asia/Bishkek':
			return 'ky-KG';
		case 'Pacific/Tarawa':
			return 'en-KI';
		case 'Pacific/Enderbury':
			return 'en-KI';
		case 'Pacific/Kiritimati':
			return 'en-KI';
		case 'Asia/Pyongyang':
			return 'ko-KP';
		case 'Asia/Seoul':
			return 'ko-KR';
		case 'Asia/Almaty':
			return 'kk-KZ';
		case 'Asia/Qyzylorda':
			return 'kk-KZ';
		case 'Asia/Qostanay':
			return 'kk-KZ';
		case 'Asia/Aqtobe':
			return 'kk-KZ';
		case 'Asia/Aqtau':
			return 'kk-KZ';
		case 'Asia/Atyrau':
			return 'kk-KZ';
		case 'Asia/Oral':
			return 'kk-KZ';
		case 'Asia/Beirut':
			return 'ar-LB';
		case 'Asia/Colombo':
			return 'si-LK';
		case 'Africa/Monrovia':
			return 'en-LR';
		case 'Europe/Vilnius':
			return 'lt-LT';
		case 'Europe/Luxembourg':
			return 'lb-LU';
		case 'Europe/Riga':
			return 'lv-LV';
		case 'Africa/Tripoli':
			return 'ar-LY';
		case 'Africa/Casablanca':
			return 'ar-MA';
		case 'Europe/Monaco':
			return 'fr-MC';
		case 'Europe/Chisinau':
			return 'ro-MD';
		case 'Pacific/Majuro':
			return 'en-MH';
		case 'Pacific/Kwajalein':
			return 'en-MH';
		case 'Asia/Yangon':
			return 'my-MM';
		case 'Asia/Ulaanbaatar':
			return 'mn-MN';
		case 'Asia/Hovd':
			return 'mn-MN';
		case 'Asia/Choibalsan':
			return 'mn-MN';
		case 'Asia/Macau':
			return 'zh-MO';
		case 'America/Martinique':
			return 'fr-MQ';
		case 'Europe/Malta':
			return 'mt-MT';
		case 'Indian/Mauritius':
			return 'en-MU';
		case 'Indian/Maldives':
			return 'dv-MV';
		case 'America/Mexico_City':
			return 'es-MX';
		case 'America/Cancun':
			return 'es-MX';
		case 'America/Merida':
			return 'es-MX';
		case 'America/Monterrey':
			return 'es-MX';
		case 'America/Matamoros':
			return 'es-MX';
		case 'America/Mazatlan':
			return 'es-MX';
		case 'America/Chihuahua':
			return 'es-MX';
		case 'America/Ojinaga':
			return 'es-MX';
		case 'America/Hermosillo':
			return 'es-MX';
		case 'America/Tijuana':
			return 'es-MX';
		case 'America/Bahia_Banderas':
			return 'es-MX';
		case 'Asia/Kuala_Lumpur':
			return 'ms-MY';
		case 'Asia/Kuching':
			return 'ms-MY';
		case 'Africa/Maputo':
			return 'pt-MZ';
		case 'Africa/Windhoek':
			return 'en-NA';
		case 'Pacific/Noumea':
			return 'fr-NC';
		case 'Pacific/Norfolk':
			return 'en-NF';
		case 'Africa/Lagos':
			return 'en-NG';
		case 'America/Managua':
			return 'es-NI';
		case 'Europe/Amsterdam':
			return 'nl-NL';
		case 'Europe/Oslo':
			return 'nb-NO';
		case 'Asia/Kathmandu':
			return 'ne-NP';
		case 'Pacific/Nauru':
			return 'en-NR';
		case 'Pacific/Niue':
			return 'en-NU';
		case 'Pacific/Auckland':
			return 'en-NZ';
		case 'Pacific/Chatham':
			return 'en-NZ';
		case 'America/Panama':
			return 'es-PA';
		case 'America/Lima':
			return 'es-PE';
		case 'Pacific/Tahiti':
			return 'fr-PF';
		case 'Pacific/Marquesas':
			return 'fr-PF';
		case 'Pacific/Gambier':
			return 'fr-PF';
		case 'Pacific/Port_Moresby':
			return 'en-PG';
		case 'Pacific/Bougainville':
			return 'en-PG';
		case 'Asia/Manila':
			return 'en-PH';
		case 'Asia/Karachi':
			return 'ur-PK';
		case 'Europe/Warsaw':
			return 'pl-PL';
		case 'America/Miquelon':
			return 'fr-PM';
		case 'Pacific/Pitcairn':
			return 'en-PN';
		case 'America/Puerto_Rico':
			return 'es-PR';
		case 'Asia/Gaza':
			return 'ar-PS';
		case 'Asia/Hebron':
			return 'ar-PS';
		case 'Europe/Lisbon':
			return 'pt-PT';
		case 'Atlantic/Madeira':
			return 'pt-PT';
		case 'Atlantic/Azores':
			return 'pt-PT';
		case 'Pacific/Palau':
			return 'en-PW';
		case 'America/Asuncion':
			return 'es-PY';
		case 'Asia/Qatar':
			return 'ar-QA';
		case 'Indian/Reunion':
			return 'fr-RE';
		case 'Europe/Bucharest':
			return 'ro-RO';
		case 'Europe/Belgrade':
			return 'sr-RS';
		case 'Europe/Kaliningrad':
			return 'ru-RU';
		case 'Europe/Moscow':
			return 'ru-RU';
		case 'Europe/Simferopol':
			return 'ru-RU';
		case 'Europe/Kirov':
			return 'ru-RU';
		case 'Europe/Astrakhan':
			return 'ru-RU';
		case 'Europe/Volgograd':
			return 'ru-RU';
		case 'Europe/Saratov':
			return 'ru-RU';
		case 'Europe/Ulyanovsk':
			return 'ru-RU';
		case 'Europe/Samara':
			return 'ru-RU';
		case 'Asia/Yekaterinburg':
			return 'ru-RU';
		case 'Asia/Omsk':
			return 'ru-RU';
		case 'Asia/Novosibirsk':
			return 'ru-RU';
		case 'Asia/Barnaul':
			return 'ru-RU';
		case 'Asia/Tomsk':
			return 'ru-RU';
		case 'Asia/Novokuznetsk':
			return 'ru-RU';
		case 'Asia/Krasnoyarsk':
			return 'ru-RU';
		case 'Asia/Irkutsk':
			return 'ru-RU';
		case 'Asia/Chita':
			return 'ru-RU';
		case 'Asia/Yakutsk':
			return 'ru-RU';
		case 'Asia/Khandyga':
			return 'ru-RU';
		case 'Asia/Vladivostok':
			return 'ru-RU';
		case 'Asia/Ust-Nera':
			return 'ru-RU';
		case 'Asia/Magadan':
			return 'ru-RU';
		case 'Asia/Sakhalin':
			return 'ru-RU';
		case 'Asia/Srednekolymsk':
			return 'ru-RU';
		case 'Asia/Kamchatka':
			return 'ru-RU';
		case 'Asia/Anadyr':
			return 'ru-RU';
		case 'Asia/Riyadh':
			return 'ar-SA';
		case 'Pacific/Guadalcanal':
			return 'en-SB';
		case 'Indian/Mahe':
			return 'en-SC';
		case 'Africa/Khartoum':
			return 'ar-SD';
		case 'Europe/Stockholm':
			return 'sv-SE';
		case 'Asia/Singapore':
			return 'en-SG';
		case 'America/Paramaribo':
			return 'nl-SR';
		case 'Africa/Juba':
			return 'en-SS';
		case 'Africa/Sao_Tome':
			return 'pt-ST';
		case 'America/El_Salvador':
			return 'es-SV';
		case 'Asia/Damascus':
			return 'ar-SY';
		case 'America/Grand_Turk':
			return 'en-TC';
		case 'Africa/Ndjamena':
			return 'fr-TD';
		case 'Indian/Kerguelen':
			return 'fr-TF';
		case 'Asia/Bangkok':
			return 'th-TH';
		case 'Asia/Dushanbe':
			return 'tg-TJ';
		case 'Pacific/Fakaofo':
			return 'en-TO';
		case 'Asia/Dili':
			return 'pt-TL';
		case 'Asia/Ashgabat':
			return 'tk-TM';
		case 'Africa/Tunis':
			return 'ar-TN';
		case 'Pacific/Tongatapu':
			return 'to-TO';
		case 'Europe/Istanbul':
			return 'tr-TR';
		case 'America/Port_of_Spain':
			return 'en-TT';
		case 'Pacific/Funafuti':
			return 'en-TU';
		case 'Asia/Taipei':
			return 'zh-TW';
		case 'Europe/Kiev':
			return 'uk-UA';
		case 'Europe/Uzhgorod':
			return 'uk-UA';
		case 'Europe/Zaporozhye':
			return 'uk-UA';
		case 'Pacific/Wake':
			return 'en-WK';
		case 'America/New_York':
			return 'en-US';
		case 'America/Detroit':
			return 'en-US';
		case 'America/Kentucky/Louisville':
			return 'en-US';
		case 'America/Kentucky/Monticello':
			return 'en-US';
		case 'America/Indiana/Indianapolis':
			return 'en-US';
		case 'America/Indiana/Vincennes':
			return 'en-US';
		case 'America/Indiana/Winamac':
			return 'en-US';
		case 'America/Indiana/Marengo':
			return 'en-US';
		case 'America/Indiana/Petersburg':
			return 'en-US';
		case 'America/Indiana/Vevay':
			return 'en-US';
		case 'America/Chicago':
			return 'en-US';
		case 'America/Indiana/Tell_City':
			return 'en-US';
		case 'America/Indiana/Knox':
			return 'en-US';
		case 'America/Menominee':
			return 'en-US';
		case 'America/North_Dakota/Center':
			return 'en-US';
		case 'America/North_Dakota/New_Salem':
			return 'en-US';
		case 'America/North_Dakota/Beulah':
			return 'en-US';
		case 'America/Denver':
			return 'en-US';
		case 'America/Boise':
			return 'en-US';
		case 'America/Phoenix':
			return 'en-US';
		case 'America/Los_Angeles':
			return 'en-US';
		case 'America/Anchorage':
			return 'en-US';
		case 'America/Juneau':
			return 'en-US';
		case 'America/Sitka':
			return 'en-US';
		case 'America/Metlakatla':
			return 'en-US';
		case 'America/Yakutat':
			return 'en-US';
		case 'America/Nome':
			return 'en-US';
		case 'America/Adak':
			return 'en-US';
		case 'Pacific/Honolulu':
			return 'en-US';
		case 'America/Montevideo':
			return 'es-UY';
		case 'Asia/Samarkand':
			return 'uz-UZ';
		case 'Asia/Tashkent':
			return 'uz-UZ';
		case 'America/Caracas':
			return 'es-VE';
		case 'Asia/Ho_Chi_Minh':
			return 'vi-VN';
		case 'Pacific/Efate':
			return 'fr-VU';
		case 'Pacific/Wallis':
			return 'fr-WF';
		case 'Pacific/Apia':
			return 'sm-WS';
		case 'Africa/Johannesburg':
			return 'en-ZA';

		default:
			return undefined;
	}
}

/*
 * Returns the timezone abbreviation
 * @param timeZone: i.e 'Australia/Sydney'
 * @param date: the current date. As the timezone abbreviation may change depending on the date
 */
export function getTimezoneAbbreviation(timeZone: string, date: Date): string | undefined {
	const locale = timezoneToLocale(timeZone);

	if (!locale) {
		return '';
	}

	try {
		const timezoneFormatter = new Intl.DateTimeFormat(locale, {
			timeZone: timeZone,
			timeZoneName: 'short',
		});

		// The date matters as the timezone name may differ depending on the date (daylight savings, summer, ect)
		const parts = timezoneFormatter.formatToParts(date);

		const tzName = parts.find((x) => x.type === 'timeZoneName')?.value;

		// Timezone name may be for example: GMT+11 or GMT-11 if we are unable to get timezone abbreviation
		if (tzName?.includes('+') || tzName?.includes('-')) {
			return '';
		}

		return tzName;
	} catch {
		return '';
	}
}

/**
 * A way to hold timezone information so it's accessible outside of a react component
 */
class TimezoneHolder {
	private workspaceTimezone?: string;
	private userAccountTimezone?: string;
	constructor(workspaceTimezone?: string, userAccountTimezone?: string) {
		this.workspaceTimezone = workspaceTimezone;
		this.userAccountTimezone = userAccountTimezone;
	}

	getWorkspaceTimezone(): string {
		// Resolve to user timezone if global/workspace timezone is undefined
		return this.workspaceTimezone || resolveUserTimezone();
	}

	getUserTimezone(): string {
		return this.userAccountTimezone || resolveUserTimezone();
	}

	setWorkspaceTimezone(workspaceTimezone?: string): void {
		// this.timezone = 'America/New_York';
		// this.timezone = 'Australia/Sydney';
		this.workspaceTimezone = workspaceTimezone;
	}

	setUserTimezone(userAccountTimezone?: string): void {
		this.userAccountTimezone = userAccountTimezone;
	}
}

const _default_1: TimezoneHolder = new TimezoneHolder();
export default _default_1;
